import { ShieldAlert } from "lucide-react";

export function LegalDisclaimer({ variant = "footer" }) {
  if (variant === "bar") {
    return (
      <div
        data-testid="legal-disclaimer-bar"
        className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-800"
      >
        <ShieldAlert className="h-4 w-4 shrink-0 mt-0.5" />
        <p>
          <strong>Disclaimer legale:</strong> Agenda-ISF-COMO agisce esclusivamente come
          intermediario tecnologico per la gestione delle agende e non interviene in alcun modo
          nella relazione professionale tra Medici e Informatori Scientifici del Farmaco.
        </p>
      </div>
    );
  }
  return (
    <footer
      data-testid="legal-disclaimer-footer"
      className="border-t border-slate-200 bg-white"
    >
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex items-start gap-2 text-xs text-slate-500">
          <ShieldAlert className="h-4 w-4 shrink-0 mt-0.5 text-slate-400" />
          <p>
            <strong className="text-slate-600">Disclaimer legale:</strong> Agenda-ISF-COMO agisce
            esclusivamente come intermediario tecnologico per la gestione delle agende e la
            prenotazione degli appuntamenti. La piattaforma non interviene nella relazione
            professionale tra Medici e Informatori Scientifici del Farmaco (ISF). · © 2026
            Agenda-ISF-COMO · Provincia di Como
          </p>
        </div>
        <div className="mt-3 flex gap-4 pl-6 text-xs">
          <a href="/privacy" className="text-blue-700 hover:underline" data-testid="footer-privacy-link">Privacy Policy</a>
          <a href="/cookie" className="text-blue-700 hover:underline" data-testid="footer-cookie-link">Cookie Policy</a>
        </div>
      </div>
    </footer>
  );
}
